// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__QLyXk","navLink":"Navbar_navLink__-xwk2","navLinkhover":"Navbar_navLinkhover__ERhq3","navSelected":"Navbar_navSelected__jEJMn"};